import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Table, InputNumber, Popconfirm, Typography, message } from 'antd';
import AddProviderModal from './components/addProviderModal';
import BatchImport from './components/batchImport';
import './index.less';
import { deleteRelation, relationList, updateRelation } from './api';
import { ProviderForm } from './components/erpSearchForm';

const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (<td {...restProps}>{editing ? (<Form.Item name={dataIndex} style={{ margin: 0 }} rules={[{ required: dataIndex !== 'sub_code', message: `请输入${title}!`, }]}>{inputNode}</Form.Item>) : (children)}</td>);
};

export default function ErpList() {
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [visibleProviderModal, setVisibleProviderModal] = useState(false);
  const [visibleImportModal, setVisibleImportModal] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [pageConfig, setPageConfig] = useState({ page: 1, page_size: 20 });
  const childrenRef = useRef();
  const searchFn = () => { setPageConfig({ ...pageConfig, page: 1 }); };

  useEffect(() => {
    async function getRelationList() {
      const searchFormValue = childrenRef.current.form.getFieldsValue();
      const { data: { code, msg, data } } = await relationList(({ ...searchFormValue, ...pageConfig }));
      if (+code === 0) {
        const { list = [], total } = data;
        setTableData(list);
        setTotalPage(total);
      } else {
        message.error(msg);
      }
    }
    getRelationList();
  }, [pageConfig]);

  const tablePageChange = (page, pageSize) => { setPageConfig({ ...pageConfig, page }); };
  const isEditing = (record) => record.id === editingKey;
  const edit = (record) => {
    form.setFieldsValue({ name: '', age: '', address: '', ...record, });
    setEditingKey(record.id);
  };
  const deleteItem = async (record) => {
    const { id, rel_company_id } = record;
    setEditingKey('');
    const { data: { code, msg } } = await deleteRelation({ id, rel_company_id });
    if (+code === 0) {
      message.success(msg, .5, searchFn());
    } else {
      message.error(msg);
    }
  };
  const cancel = () => { setEditingKey(''); };
  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...tableData];
      const index = newData.findIndex((item) => key === item.id);

      if (index > -1) {
        const item = newData[index];
        const { data: { code, msg } } = await updateRelation({ ...item, ...row });
        if (+code === 0) {
          message.success(msg);
          newData.splice(index, 1, { ...item, ...row });
          setTableData(newData);
          setEditingKey('');
        } else {
          message.error(msg);
        }
      } else {
        newData.push(row);
        setTableData(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };
  const columns = [
    {
      title: '平台供应商名称',
      dataIndex: 'rel_company_pname',
      width: '20%',
      editable: false,
    },
    {
      title: 'ERP供应商名称',
      dataIndex: 'rel_company_name',
      width: '20%',
      editable: true,
    },
    {
      title: 'ERP供应商编码',
      dataIndex: 'primary_code',
      width: '20%',
      editable: true,
    },
    {
      title: 'ERP供应商二级细分',
      dataIndex: 'sub_code',
      width: '20%',
      editable: true,
    },
    {
      title: '操作',
      dataIndex: 'operation',
      width: '10%',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link onClick={() => save(record.id)} style={{ marginRight: 8 }}>保存</Typography.Link>
            <Popconfirm title=" 确定取消?" onConfirm={cancel}><span>取消</span></Popconfirm>
          </span>
        ) : (
          <span>
            <Typography.Link style={{ marginRight: 8 }} disabled={editingKey !== ''} onClick={() => edit(record)}>编辑</Typography.Link>
            <Popconfirm title=" 确定删除?" onConfirm={() => deleteItem(record)}><Typography.Link>删除</Typography.Link></Popconfirm>
          </span>
        );
      },
    },
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {return col;}

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'age' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <div>
      <div className='erp-list-title'>ERP供应商清单</div>
      <ProviderForm ref={childrenRef} searchFn={searchFn} />
      <div className='erp-list-import-btn-container' style={{ marginBottom: '20px' }}>
        <Button type='primary' style={{ marginRight: '20px' }} onClick={() => { setVisibleImportModal(true); }}>批量导入</Button>
        <Button type='primary' onClick={() => { setVisibleProviderModal(true); }}>新增供应商</Button>
      </div>
      <Form form={form} component={false}>
        <Table
          components={{ body: { cell: EditableCell } }}
          dataSource={tableData}
          columns={mergedColumns}
          rowClassName="editable-row"
          rowKey='id'
          pagination={{
            pageSize: pageConfig.page_size,
            total: totalPage,
            current: pageConfig.page,
            onChange: tablePageChange
          }}
        />
      </Form>
      {visibleProviderModal ? <AddProviderModal hideModal={() => setVisibleProviderModal()} searchFn={searchFn} /> : null}
      {visibleImportModal ? <BatchImport hideModal={() => setVisibleImportModal()} searchFn={searchFn} /> : null}
    </div>
  );
};



